import React, { useContext, useState, useEffect, useRef } from "react";
import { CartContext } from "../../contexts/CartContext";
import { Link, useNavigate } from "react-router-dom";
import { GoClock } from "react-icons/go";
import { AddressContext } from "../../contexts/AddressContext";
import { PagoForm } from "../components/PagoForm";
import { Timeline } from "../components/Timeline";
import { formatPrice } from "../../utils/formatPrice";
import { FaCheckSquare } from "react-icons/fa";
import { FaCircle } from "react-icons/fa";
import { MercadoPagoWallet } from "../components/MercadoPagoWallet";
import { FormContext } from "../../contexts/FormContext";


export const Checkout = () => {
  const { formData, updateField } = useContext(FormContext);
  const { cartSummary, cantidades } = useContext(CartContext);
  const { address, reference, clearAddress } = useContext(AddressContext);

  const [showAddAddress, setShowAddAddress] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [deliveryType, setDeliveryType] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('Miércoles, 06 de Marzo a las 10:00 AM');
  const [paymentFormData, setPaymentFormData] = useState({});
  const [showUserData, setShowUserData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");
  const navigate = useNavigate();

  // useEffect(() => {
  //   console.log("Resumen del carrito en checkout:", cartSummary);
  // }, [cartSummary]);

  const previousDeliveryType = useRef(null);

  useEffect(() => {
    let newType = null;

    if (address && reference) {
      setSelectedOption('address');
      setDeliveryType('Entrega a domicilio');
      newType = 'address';
    } else if (selectedOption === 'store') {
      newType = 'store';
    }

    if (newType && previousDeliveryType.current !== newType) {
      updateField('tipoEntrega', newType);
      previousDeliveryType.current = newType;
    }
  }, [address, reference, selectedOption, updateField]);


  const handleChooseAddressClick = () => {
    setSelectedOption('address');
    setShowAddAddress(true);
    setDeliveryType('Entrega a domicilio');
    updateField('tipoEntrega', 'address');
  };

  const handleAddAddressClick = () => {
    navigate('/agregar-direccion');
  };

  const handleRemoveAddress = () => {
    clearAddress();
    setShowAddAddress(true);
  };

  const handleStorePickupClick = () => {
    setSelectedOption('store');
    setShowAddAddress(false);
    setDeliveryType('Recojo en tienda');
    updateField('tipoEntrega', 'store');
  };

  const validateFormData = (data) => {
    if (!data.nombre || !data.apellidos || !data.dni || !data.telefono) {
      return false;
    }
    if (data.telefono.length !== 9) {
      return false;
    }
    return true;
  };

  const handlePaymentFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    const isValid = validateFormData(data);
    if (isValid) {
      setLoading(true);
      setTimeout(() => {
        setPaymentFormData(data);
        setLoading(false);
        setShowUserData(true);
        setFormError("");
      }, 2000);
    } else {
      setFormError("Por favor, complete todos los campos correctamente.");
    }
  };

  const totalProductos = cartSummary.cantidades.reduce((total, cantidad) => total + cantidad, 0);

  return (
    <div className="font-family-montserrat container-checkout">
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
      <div className="extrabold-800 color-520FDA font20 font21-5 pad-18 txt-center pad-carrito-compras">
        CHECKOUT
      </div>

      <Timeline currentStep={2} />

      <div className="container-general">
        <div className="bloque1">
          <div className="flex-container flex-center txt-center font15 font16-5 txt-negrita">
            ¿En dónde recibirás tu pedido?
          </div>

          <div className="container-ubicacion">
            <div className="container-ubicacion-tipo">
              <label
                className="radio-label"
                onClick={handleChooseAddressClick}
                style={{ cursor: 'pointer' }}
              >
                <div className="radio-input">
                  <input type="radio" name="producto" checked={selectedOption === 'address'} readOnly />
                  <span className="custom-radio"></span>
                </div>
                <div className="icon-text-container">
                  <div className="box-icon">
                    <img src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=OFFICE_Mesa%20de%20trabajo%201%202.png&version_id=null" alt="icono casa" />
                  </div>
                  <div className="box-text">
                    <h3 className="font14 font15-5 txt-semibold color-blanco mr-auto">
                      Elige tu dirección
                    </h3>
                    <p className="font10 font11-5 color-blanco mr-auto">
                      Recibe tu pedido en donde estés
                    </p>
                  </div>
                </div>
              </label>

              {showAddAddress && !address && !reference && (
                <label
                  className="radio-label container-agregar-direccion"
                  onClick={handleAddAddressClick}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="text-add-direccion flex-container container-100">
                    <h3 className="text-add-direccion-v2 mr-auto">
                      + Agregar dirección
                    </h3>
                  </div>
                </label>
              )}

              {address && reference && (
                <div className="address-summary">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 className="font14 font15-5 txt-semibold color-blanco mr-auto">
                      Dirección guardada
                    </h3>
                    <div
                      className="close-address"
                      onClick={handleRemoveAddress}
                      style={{ background: 'transparent', border: 'none', color: '#000', fontSize: '16px', cursor: 'pointer' }}
                    >
                      x
                    </div>
                  </div>
                  <p className="font10 font11-5 color-blanco mr-auto">
                    {address}
                  </p>
                  <p className="font10 font11-5 color-blanco mr-auto">
                    {reference}
                  </p>
                </div>
              )}

              <label
                className="radio-label"
                onClick={handleStorePickupClick}
                style={{ cursor: 'pointer' }}
              >
                <div className="radio-input">
                  <input type="radio" name="producto" checked={selectedOption === 'store'} readOnly />
                  <span className="custom-radio"></span>
                </div>
                <div className="icon-text-container">
                  <div className="box-icon">
                    <img src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=tienda-02%201.png&version_id=null" alt="tienda icono" />
                  </div>
                  <div className="box-titulo">
                    <h3 className="font14 font15-5 color-blanco mr-auto">
                      Recojo en tienda
                    </h3>
                  </div>
                </div>
              </label>

              {selectedOption === 'store' && (
                <div className="box-direccion">
                  <div>
                    <img src="/img_publics/tienda.png" alt="tienda" />
                  </div>
                  <div className="info-direccion">
                    <div className="box-texto-direccion">
                      <h3 className="mr-auto font14 font15-5 txt-negrita">Tujillo</h3>
                      <p className="mr-auto font14 font15-5">
                        Jr. Ayacucho 463, Centro Turístico, Trujillo, Perú, 13001
                      </p>
                    </div>
                    <div className="box-horario-direccion">
                      <GoClock size={14} color="#27D309" />
                      <div className="font10 font11-5 txt-semibold color-00E5E5">
                        09:00 AM - 5:30 PM
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="container-horario-recojo">
              <div className="box-horario">
                <div className="container-a">
                  <img
                    src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=persona-office-xs.png&version_id=null"
                    alt="persona-office"
                  />
                </div>

                <div className="container-b">
                  <div className="box-texto">
                    <div className="recojo-horario">
                      <img
                        src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=horario-05%201.png&version_id=null"
                        alt="horario icono"
                        className="horario-icon"
                      />
                      <h4 className="font16 font17-5 txt-semibold">Horario de recojo</h4>
                    </div>
                  </div>
                  <div className="check-horario">
                    <FaCheckSquare size={17} style={{ color: "#27D309" }} />
                    <div className="parrafos-horario txt-semibold">
                      <p className="font13 font14-5">
                        Tu pedido estará listo a partir desde el
                      </p>
                      <p className="font12-regalo font13-5 color-520FDA">
                        Miércoles, 06 de Marzo a las 10:00 AM </p>
                    </div>
                  </div>
                </div>

                <div className="container-c">
                  <div className=" box-informacion font12-regalo font13-5 txt-negrita500">
                    <ul>
                      <li>
                        <FaCircle style={{ color: "#27D309", fontSize: "14px" }} />
                        <p>Te enviaremos un mensaje cuando tu pedido esté listo para recoger.</p>
                      </li>
                      <li>
                        <FaCircle style={{ color: "#27D309", fontSize: "14px" }} />
                        <p>Una vez que tu pedido esté listo, tendrás un plazo máximo para de 48 horas.</p>
                      </li>
                      <li>
                        <FaCircle style={{ color: "#27D309", fontSize: "9px" }} />
                        <p>Recuerda que debes llevar...</p>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>


            <div className="container-pago container-100">
              <PagoForm onSubmit={handlePaymentFormSubmit} />
            </div>

            <div className="container-comprobar">
              <div className="font15 font16-5 color-520FDA txt-semibold margin17">
                Comprobar los datos antes de finalizar su compra
              </div>
              <div className="contenedor-datos margin17 flex-container justificar">
                <div className="img-container-comprobar">
                  <img src="/img_publics/caja.png" alt="caja" />
                </div>
                <div className="contenedor-textos">
                  <div className="font15 font16-5 txt-negrita500">Despachado por:</div>
                  <p className="font13">Juanito Perez</p>
                </div>
              </div>

              <div className="contenedor-datos margin17 flex-container justificar">
                <div className="img-container-comprobar">
                  <img src="/img_publics/ubicacion.png" alt="ubicacion" />
                </div>
                <div className="contenedor-textos">
                  <div className="font15 font16-5 txt-negrita500">Tipo de entrega:</div>
                  <p className="font13 font14-5">
                    {deliveryType === 'Recojo en tienda' ? (
                      <>
                        Recojo en tienda
                        <br />
                        Jr. Ayacucho 463, Centro Turístico, Trujillo, Perú, 13001
                      </>
                    ) : (
                      <>
                        Entrega a domicilio
                        <br />
                        {address}
                      </>
                    )}
                  </p>
                </div>
              </div>

              <div className="contenedor-datos margin17 flex-container justificar">
                <div className="img-container-comprobar">
                  <GoClock />
                </div>
                <div className="contenedor-textos">
                  <div className="font15 font16-5 txt-negrita500">
                    Fecha y hora de entrega:
                  </div>
                  <p className="font13 font14-5">{deliveryDate}</p>
                </div>
              </div>

              <div className="contenedor-datos margin17 flex-container justificar">
                <div className="img-container-comprobar">
                  <img src="/img_publics/factura.png" alt="factura" />
                </div>
                <div className="contenedor-textos">
                  <div className="font15 font16-5 txt-negrita500">Comprobante de pago:</div>
                  <p className="font13 font14-5">Lorem ipsum</p>
                </div>
              </div>

              <div className="contenedor-datos margin17 flex-container justificar">
                <div className="img-container-comprobar">
                  <img src="/img_publics/tarjeta-de-credito.png" alt="tarjeta-de-credito" />
                </div>
                <div className="contenedor-textos">
                  <div className="font15 font16-5 txt-negrita500">Medio de pago:</div>
                </div>
              </div>
            </div>
          </div>


        </div>

        <div className="bloque2">
          <div className="container-resumen container-100">
            <div className="font15 font16-5 txt-negrita">Resumen del pedido</div>
            {showUserData && (
              <div className="user-data-card">
                <div className="user-data-content">
                  <div className="user-data-item">
                    <span className="user-data-value font15">{`${paymentFormData.nombre} ${paymentFormData.apellidos}`}</span>
                  </div>
                  <div className="user-data-item">
                    <span className="user-data-value font15">{paymentFormData.email}</span>
                  </div>
                  <div className="user-data-item">
                    <span className="user-data-value font15">{paymentFormData.telefono}</span>
                  </div>
                </div>
              </div>
            )}


            {cartSummary.cartItems.map((item, index) => (
              <div className="box-producto flex-container flex-end" key={index}>
                <div className="img-producto position-relative flex-container flex-center container-100">
                  <img
                    src={process.env.REACT_APP_URL_MINIO+item.productoImgUrlPrincipal}
                    alt={item.productoNombre}
                  />
                  <div className="circulo position-absolute">
                    {cartSummary.cantidades[index]}
                  </div>
                </div>
                <div className="producto-texto flex-container txt-end">
                  <p className="font13 font14-5 txt-semibold">
                    {item.productoNombre}
                  </p>
                  <p className="txt-semibold font15 font16-5 color-520FDA">
                    {/* S/ {item.productoPrecio} */}
                    {formatPrice(item.productoPrecio)}
                  </p>
                </div>
              </div>
            ))}

            <div className="font13 font14-5 txt-semibold" style={{ textAlign: 'end', marginTop: '10px' }}>
              Total de productos: {totalProductos} {/* Resumen del número de productos */}
            </div>
          </div>



          <div className="container-detalle-compra">
            <div className="detalle-compra flex-container ancho-unset">
              <div className="font12-semibold font13-5">
                <div className="fila1">
                  <div className="column1">Subtotal</div>
                  <div className="column2">{formatPrice(cartSummary.subtotal)}</div>
                </div>

                <div className="fila2 border-top border-bottom">
                  <div className="column1">Cupón</div>
                  <div className="column2 color-520FDA">
                    {cartSummary.porcentajeDescuento > 0 ? `- ${cartSummary.porcentajeDescuento}%` : "-"}
                  </div>
                </div>

                <div className="fila3 border-bottom">
                  <div className="column1">Costo total</div>
                  <div className="column2">{formatPrice(cartSummary.costoTotal)}</div>
                </div>

                <div className="fila4">
                  <div className="column1">Ahorraste</div>
                  <div className="column2">{formatPrice(cartSummary.descuentoCupon)}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-100 flex-container flex-center">
            <MercadoPagoWallet />
          </div>

        </div>
      </div>
    </div>
  );
};